module.exports = function(arr){
    let str="";
    for(let i in arr){
        str +=arr[i]+",";
    }
    return str.substring(0,str.length-1);
}
